<template>
  <img
    class="size-24"
    :class="{ 'md:size-16 lg:size-24': mdResize }"
    :src="item.icon"
    :alt="item.name"
    loading="lazy"
    :title="item.name"
    width="96"
    height="96"
    @error="onError"
  />
</template>

<script setup lang="ts">
import type { StrapiMinecraftModpack } from '#variant/apollo/types/types';

defineProps<{
  item: StrapiMinecraftModpack;
  mdResize?: boolean;
}>();

const onError = (event: Event) => {
  const image = event.currentTarget as HTMLImageElement;
  image.onerror = null;
  image.src = 'https://cdn.g-portal.com/images/modpack/placeholder.webp';
};
</script>
